import React, { useRef, useState } from "react";
import {
  Trans,
  useTranslation,
  useI18next,
  Link,
} from "gatsby-plugin-react-i18next";
import { LANGUAGES, Locales } from "../../locales/languages";

export const Accordion: React.FC = () => {
  const { t } = useTranslation();
  const [active, setActive] = useState(false);
  const [height, setHeight] = useState("0px");
  const [rotate, setRotate] = useState("transform duration-700 ease");
  const contentSpace = useRef<HTMLDivElement>(null);

  const { language: currentLanguage, languages, originalPath } = useI18next();

  function toggleAccordion() {
    setActive((prev) => !prev);
    setHeight(active ? "0px" : `${contentSpace.current?.scrollHeight ?? 0}px`);
    setRotate(
      active
        ? "transform duration-300 ease"
        : "transform duration-700 ease rotate-180",
    );
  }

  return (
    <div className="flex flex-col">
      <button
        className="py-6 box-border appearance-none cursor-pointer focus:outline-none flex items-center justify-center flex flex-row gap-6"
        onClick={toggleAccordion}
      >
        <p className="inline-block text-footnote text-center text-16 font-medium whitespace-nowrap lg:hover:text-white transition">
          <Trans>{LANGUAGES[currentLanguage as Locales]}</Trans>
        </p>
        <svg
          className={`${rotate} inline-block w-16 h-16 fill-current`}
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.6894 5.28443C13.2753 4.90519 12.6029 4.90519 12.1888 5.28443L8.00025 9.51089L3.81118 5.28443C3.39707 4.90519 2.7247 4.90519 2.31058 5.28443C1.89647 5.66367 1.89647 6.2805 2.31058 6.65974L7.18352 11.5761C7.40781 11.7818 7.70703 11.8731 8.00025 11.8549C8.29348 11.8731 8.5922 11.7818 8.81648 11.5761L13.6894 6.65974C14.1035 6.2805 14.1035 5.66367 13.6894 5.28443Z"
            fill="current"
          />
        </svg>
      </button>
      <div
        ref={contentSpace}
        style={{ maxHeight: `${height}` }}
        className="overflow-hidden transition-max-height duration-300 ease-in-out"
      >
        <div className="pb-16">
          <ul>
            {languages.map((lang) => (
              <li className="dropdown-list-item-lang mt-16" key={lang}>
                <Link to={originalPath} language={lang}>
                  <Trans>{LANGUAGES[lang as Locales]}</Trans>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
